/**
 * 业务层失败（HTTP 200 但 success: false 等）：返回应展示给用户的 message，否则 null。
 */
export const getApiBusinessFailureMessage = (data: unknown): string | null => {
  if (!data || typeof data !== 'object') return null;
  const root = data as Record<string, unknown>;
  const failed =
    root.success === false ||
    (root.data &&
      typeof root.data === 'object' &&
      (root.data as Record<string, unknown>).success === false);
  if (!failed) return null;
  return extractApiMessage(data) || '请求失败';
};

/** 从接口异常或响应体中尽量提取用户可读错误信息。 */
export const extractApiMessage = (input: any): string => {
  if (!input) return '';
  if (typeof input === 'string') return input;
  const direct =
    input?.message ||
    input?.msg ||
    input?.error?.message ||
    input?.error ||
    input?.data?.message ||
    input?.data?.msg ||
    input?.data?.error?.message ||
    input?.data?.error;
  if (typeof direct === 'string' && direct.trim()) return direct.trim();
  return '';
};

/** fetch 被取消或卸载时静默（避免重复请求时仍可弹 Toast）。 */
export const isAbortLike = (e: unknown): boolean => {
  if (!e || typeof e !== 'object') return false;
  const err = e as DOMException & { message?: string; name?: string };
  if (err.name === 'AbortError') return true;
  const msg = String(err.message ?? '').toLowerCase();
  return msg.includes('abort') || msg.includes('aborted');
};
